import React from "react";
import { Col, Divider, Flex, Typography } from "antd";
import { formatCurrencyOperationCodesForDisplay, ItemInfo } from "components";
import { formatWithDecimals } from "utils";
import {
  CONTRACT_CURRENCY_ENUM,
  contractCurrencyName,
  FIAT_CURRENCY_ENUM,
  NETWORK_TEXT,
  TOKEN_BALANCE_ENUM,
} from "interfaces";

interface VerificationStepProps {
  destinationWallet: string;
  fiatAmount: string | number;
  digitalAmount: string | number;
  network: string;
  bidFrame: boolean;
  isCustomer?: boolean;
  currency?: string;
  fiatCurrency?: string;
  currencyOperationCode: string;
}

export const VerificationStep: React.FC<VerificationStepProps> = ({
  destinationWallet,
  fiatAmount,
  digitalAmount,
  network,
  bidFrame,
  isCustomer,
  currency,
  fiatCurrency,
  currencyOperationCode,
}) => {
  const fiatAmountTitle = isCustomer ? "Сумма заявки" : "Сумма выплаты";
  const fiatCurrencyText = fiatCurrency as TOKEN_BALANCE_ENUM;

  return (
    <Flex vertical gap="xsmall">
      <Typography.Title level={2}>Проверьте данные заявки</Typography.Title>
      <Divider className="margin-bottom-md margin-top-none" />
      <Col>
        <ItemInfo
          vertical={false}
          title={fiatAmountTitle}
          text={`${formatWithDecimals(fiatAmount.toString())} ${isCustomer ? (contractCurrencyName[fiatCurrencyText] ?? fiatCurrency) : ""}`}
        />
        <ItemInfo
          vertical={false}
          title="Код вида операции"
          text={formatCurrencyOperationCodesForDisplay(currencyOperationCode)}
        />
        {/* <ItemInfo vertical={false} title="Платеж в цифровой валюте" text={bidFrame ? "Да" : "Нет"} /> */}
        {digitalAmount && (
          <ItemInfo
            vertical={false}
            title="Сумма цифровой валюты"
            text={`${formatWithDecimals(digitalAmount.toString())} ${currency}`}
          />
        )}
        {network && (
          <ItemInfo
            vertical={false}
            title="Сеть блокчейн"
            text={`${isCustomer && network === "ETH" ? NETWORK_TEXT.ETH : network}`}
          />
        )}
        {destinationWallet && <ItemInfo vertical={false} title="Кошелёк получателя" text={destinationWallet} />}
      </Col>
      <Divider className="margin-bottom-md margin-top-none" />
    </Flex>
  );
};
